var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import * as actions from '../constants/actionTypes';
import callApi from '../graphql/callApi';
import { LabelType, PackageType, PaymentStatus, TripStatus, TripType, } from '../graphql/generated/api';
import sagaFactory from '../utils/sagaFactory';
export var getTrip = sagaFactory('getTrip', actions.getTrip, callApi.getTrip, 'trip');
export var getDriverTripByTripId = sagaFactory('getDriverTripByTripId', actions.getDriverTripByTripId, callApi.getDriverTripByTripId, 'driverTripByTripId');
export var getDriverTrips = sagaFactory('getDriverTrips', actions.getDriverTrips, callApi.getDriverTrips, 'driverTrips');
export function createTrip(_a) {
    var req, resTrip, pack, err_1, message;
    var _b, _c, _d, _e;
    var payload = _a.payload, next = _a.next;
    return __generator(this, function (_f) {
        switch (_f.label) {
            case 0:
                _f.trys.push([0, 11, , 13]);
                req = {
                    input: {
                        type: payload.type,
                        addressId: payload.addressId,
                        date: payload.date,
                        method: payload.method,
                        status: TripStatus.PENDING,
                        source: payload.source,
                        createdBy: payload.createdBy,
                    },
                };
                return [4 /*yield*/, call(callApi.createTrip, req)];
            case 1:
                resTrip = _f.sent();
                if (!((_c = (_b = resTrip.data) === null || _b === void 0 ? void 0 : _b.createTrip) === null || _c === void 0 ? void 0 : _c.id)) return [3 /*break*/, 8];
                return [4 /*yield*/, call(callApi.createPackage, {
                        input: __assign(__assign({ tripId: resTrip.data.createTrip.id, labelType: (payload === null || payload === void 0 ? void 0 : payload.isConsolidationEnabled) ? LabelType.CONSOLIDATED : LabelType.PHYSICAL, description: payload.description, retailerId: payload.retailerId, paymentStatus: PaymentStatus.UNPAID, partnerCode: payload.partnerCode, source: payload.source, serviceType: payload.serviceType, createdBy: payload.createdBy }, (TripType.PICKUP === payload.type
                            ? { isSwap: Boolean(payload.isSwap) }
                            : { isSwap: false })), { date: resTrip.data.createTrip.date, method: payload.method, type: PackageType[payload.type] }),
                    })];
            case 2:
                pack = _f.sent();
                if (!((_d = pack.data) === null || _d === void 0 ? void 0 : _d.createPackage)) return [3 /*break*/, 5];
                return [4 /*yield*/, call(callApi.confirmTrip, { id: resTrip.data.createTrip.id })];
            case 3:
                _f.sent();
                return [4 /*yield*/, put({
                        type: actions.createTrip.type.SUCCESS,
                        payload: __assign(__assign({}, resTrip.data.createTrip), { packages: [__assign({}, (_e = pack.data) === null || _e === void 0 ? void 0 : _e.createPackage)] }),
                    })];
            case 4:
                _f.sent();
                next(resTrip.data.createTrip);
                return [3 /*break*/, 7];
            case 5: return [4 /*yield*/, call(callApi.deleteTrip, { id: resTrip.data.createTrip.id })];
            case 6:
                _f.sent();
                throw new Error('Something went wrong, try aging later');
            case 7: return [3 /*break*/, 10];
            case 8: return [4 /*yield*/, put({
                    type: actions.createTrip.type.FAILED,
                })];
            case 9:
                _f.sent();
                next(false, 'Something go wrong during trip creation');
                _f.label = 10;
            case 10: return [3 /*break*/, 13];
            case 11:
                err_1 = _f.sent();
                message = err_1.message;
                console.error('createTrip', message);
                return [4 /*yield*/, put({
                        type: actions.createTrip.type.FAILED,
                    })];
            case 12:
                _f.sent();
                next(false, message);
                return [3 /*break*/, 13];
            case 13: return [2 /*return*/];
        }
    });
}
export var submitTrip = sagaFactory('submitTrip', actions.submitTrip, callApi.confirmTrip, 'confirmTrip');
export var batchUpdateTrips = sagaFactory('batchUpdateTrips', actions.batchUpdateTrips, callApi.batchUpdateTrip, 'batchUpdateTrip');
export var getTripETAValue = sagaFactory('getTripETAValue', actions.getTripETAValue, callApi.getTripETAValue, 'tripETAValue');
export var refreshTripEATValue = sagaFactory('refreshTripEATValue', actions.refreshTripEATValue, callApi.refreshTripEATValue, 'refreshTripEATValue');
export var getEATRecencyThreshold = sagaFactory('getEATRecencyThreshold', actions.getEATRecencyThreshold, callApi.getEATRecencyThreshold, 'EATRecencyThreshold');
export var createTripAudit = sagaFactory('createTripAudit', actions.createTripAudit, callApi.createTripAudit, 'createTripAudit');
export var assignUserToTripAudit = sagaFactory('assignUserToTripAudit', actions.assignUserToTripAudit, callApi.assignUserToTripAudit, 'assignUserToTripAudit');
export var completeTripAudit = sagaFactory('completeTripAudit', actions.completeTripAudit, callApi.completeTripAudit, 'completeTripAudit');
export var setBadCompletionNotes = sagaFactory('setBadCompletionNotes', actions.setBadCompletionNotes, callApi.setBadCompletionNotes, 'setBadCompletionNotes');
export var completeSaverReviewForTripAudit = sagaFactory('completeSaverReviewForTripAudit', actions.completeSaverReviewForTripAudit, callApi.completeSaverReviewForTripAudit, 'completeSaverReviewForTripAudit');
export var assignSaverToTripAudit = sagaFactory('assignSaverToTripAudit', actions.assignSaverToTripAudit, callApi.assignSaverToTripAudit, 'assignSaverToTripAudit');
function tripSaga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, takeEvery(actions.getTrip.type.REQUEST, getTrip)];
            case 1:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.getDriverTripByTripId.type.REQUEST, getDriverTripByTripId)];
            case 2:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.getDriverTrips.type.REQUEST, getDriverTrips)];
            case 3:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.createTrip.type.REQUEST, createTrip)];
            case 4:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.submitTrip.type.REQUEST, submitTrip)];
            case 5:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.batchUpdateTrips.type.REQUEST, batchUpdateTrips)];
            case 6:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.getTripETAValue.type.REQUEST, getTripETAValue)];
            case 7:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.refreshTripEATValue.type.REQUEST, refreshTripEATValue)];
            case 8:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.getEATRecencyThreshold.type.REQUEST, getEATRecencyThreshold)];
            case 9:
                _a.sent();
                return [4 /*yield*/, takeLatest(actions.createTripAudit.type.REQUEST, createTripAudit)];
            case 10:
                _a.sent();
                return [4 /*yield*/, takeLatest(actions.assignUserToTripAudit.type.REQUEST, assignUserToTripAudit)];
            case 11:
                _a.sent();
                return [4 /*yield*/, takeLatest(actions.completeTripAudit.type.REQUEST, completeTripAudit)];
            case 12:
                _a.sent();
                return [4 /*yield*/, takeLatest(actions.setBadCompletionNotes.type.REQUEST, setBadCompletionNotes)];
            case 13:
                _a.sent();
                return [4 /*yield*/, takeEvery(actions.completeSaverReviewForTripAudit.type.REQUEST, completeSaverReviewForTripAudit)];
            case 14:
                _a.sent();
                return [4 /*yield*/, takeLatest(actions.assignSaverToTripAudit.type.REQUEST, assignSaverToTripAudit)];
            case 15:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
export default tripSaga;
//# sourceMappingURL=trip.js.map